import React, {useCallback} from 'react'
import {Row, Col, H6, ButtonLink, withTooltip, OverdueIcon, Caption, HelpIcon} from '@modifi/ui'
import {useTranslation, KEY_SHARED} from '@modifi/plugin-i18n'
import {translationFilter, useCountrySpecificTranslationKey} from '@modifi/plugin-onboarding'
import {warning} from '@modifi/colors'

const TooltipIcon = withTooltip(OverdueIcon) as React.ComponentType<any>
const HelpIconWithTooltip = withTooltip(HelpIcon) as React.ComponentType<any>

type DocumentHeaderProps = {
  documentType: string
  className?: string
  filePath?: string | null
  showFilePreview?: boolean
  pageDescription?: string | null
  requiredDocs?: string[]
}

const DocumentHeader: React.VFC<DocumentHeaderProps> = ({
  className,
  documentType,
  filePath = null,
  showFilePreview = false,
  pageDescription = null,
  requiredDocs = [],
}) => {
  const {t} = useTranslation(KEY_SHARED)
  const {t: charonT} = useTranslation('charon')
  const countrySpecificKey = useCountrySpecificTranslationKey()

  const handlePreviewClick = useCallback((filePathToOpen: string) => {
    window.open(filePathToOpen)
  }, [])

  const currentDocIsRequired = (requiredDocs || [])?.includes(documentType)

  return (
    <Row data-ident="document-type-headline" data-target={documentType} alignItems="center">
      {currentDocIsRequired && (
        <Col auto>
          <TooltipIcon
            color={warning}
            height={32}
            width={32}
            tooltipTheme="admin"
            tooltipPlacement="top"
            tooltipContent={charonT('trade-information.document-required.tooltip-content')}
            contentWidth={200}
          />
        </Col>
      )}
      <Col auto className={className} mb={8}>
        <H6 mb={0}>{t(countrySpecificKey(`document-type.${documentType}`))}</H6>
        <Caption>{translationFilter(t, `document-type.${documentType}.description`)}</Caption>
      </Col>
      {pageDescription && (
        <Col auto>
          <HelpIconWithTooltip
            tooltipContent={pageDescription}
            tooltipPlacement="top"
            contentWidth={300}
          />
        </Col>
      )}
      {showFilePreview && filePath && (
        <Col auto>
          <ButtonLink data-target="preview file" onClick={() => handlePreviewClick(filePath)}>
            {charonT('document-upload.preview-example.label')}
          </ButtonLink>
        </Col>
      )}
    </Row>
  )
}

export default DocumentHeader
